<ng-container>
  <div *transloco="let t" class="cursor-pointer">
    @if (label) {
      <label (click)="onLabelFocus()">
        <p class="regular trim-text d-inline">
          {{ t(label) }}
        </p>
        @if (errors?.['required']) {
          <p class="regular d-inline ps-1"><small>*</small></p>
        }
      </label>
    }
    <app-dropdown #dropdownRef [disabled]="disabled || itemLabelArray.length === 0" (dropdownClosed)="dropdownClosed($event)"
                  [isDropdownListFullWidth]="isDropdownListFullWidth" [width]="width" [minWidth]="minWidth">
      <div dropdownPanel>
        <div class="panel" dropdownToggle [class.error]="touched && invalid"
             [class.disabled]="disabled"
           >
          @if (!displaySelectionAsBadge) {
            <span class="selection">
                  {{ getSelectedValueLabel() }}
            </span>
          } @else {
            @if (selectedValue !== null && selectedValue !== undefined ) {
              <app-badge [label]="getSelectedValueLabel()" badgeClass="badge-l" [badgeColor]="getItemClass()"/>
            } @else {
              <span></span>
            }
          }
        </div>
      </div>
      <div dropdownContent>
        @if (itemLabelArray.length > SEARCH_ELEMENT_BREAKPOINT) {
          <div class="search-wrapper">
              <i class="bi bi-search ps-1"></i>
              <input [placeholder]="t('explore.search')" class="search-input ps-2 d-flex"
                [ngModel]="searchText" (ngModelChange)="onSearch($event)"/>
          </div>
        }
        <div class="dropdown-list-wrapper">
          @if (hasDefault) {
          <div (click)="setDefaultValue()" dropdownItem class="select-item">
            <span class="option-label" [ngClass]="{'selected':defaultValue === selectedValue}">
                {{ defaultLabel }}
            </span>
          </div>
          }
          @if (filteredItemLabelArray.length > 0) {
            @for (item of filteredItemLabelArray;track item.item;let idx = $index) {
              <div (click)="onSelect(item.item)" dropdownItem class="select-item">
                <span class="option-label" [ngClass]="{'selected': item.item === selectedValue}">
                    {{ item.label }}
                </span>
              </div>
            }
          }
          @else {
          <span class="empty-list">
          {{ t("emptyState.not.able.to.find") }}
          </span>
          }
        </div>
      </div>
    </app-dropdown>
    @if (invalid && touched) {
      @for (errorMessage of errors | errorMessages;track errorMessage) {
        <span class="errorMes pt-1">{{ errorMessage }} </span>
      }
    }
  </div>
</ng-container>
